// Benefit bar: when the items don't fit (mobile), show one at a time and rotate gently.
// Pauses on hover/focus/touch and never auto-rotates with prefers-reduced-motion.
if (!customElements.get('oile-ticker')) {
  customElements.define(
    'oile-ticker',
    class OileTicker extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('ul');
        this.items = [...this.list.children];
        this.index = 0;
        this.paused = false;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        ['mouseenter', 'focusin', 'touchstart'].forEach((e) =>
          this.addEventListener(e, () => (this.paused = true), { passive: true })
        );
        ['mouseleave', 'focusout', 'touchend', 'touchcancel'].forEach((e) =>
          this.addEventListener(e, () => (this.paused = false), { passive: true })
        );

        if (this.hasAttribute('data-autoplay') && !this.reduceMotion && this.items.length > 1) {
          this.timer = setInterval(() => this.next(), Number(this.dataset.interval) || 5000);
        }
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      next() {
        if (this.paused || document.hidden) return;
        if (this.list.scrollWidth <= this.list.clientWidth + 1) return; // everything visible (desktop)
        this.index = (this.index + 1) % this.items.length;
        this.list.scrollTo({ left: this.items[this.index].offsetLeft - this.list.offsetLeft, behavior: 'smooth' });
      }
    }
  );
}
